export const ROLE_ASSIGNMENT_TEXT = {
  TEAM_REP: 'Tap to assign',
  NOT_SET: 'Not Set',
}
